import {create} from 'zustand';

const popupStore = create((set) => ({
    isOpen: false,
    isOpenMobile: false,
    data: null,
    key: null,
    setPopup: ({isOpen, data}) => set({isOpen, data}),
    setPopupMobile: ({isOpenMobile, data}) => set({isOpenMobile, data}),
}));

export default popupStore;